<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-horizontal">
        <div
          :class="{ 'has-error': validations.name_km }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="name_km"
          >{{ $t("field.label.project_type_km") }}</label>
          <div class="col-sm-9">
            <input
              id="name_km"
              v-model="projectType.name_km"
              :placeholder="$t('field.pla.project_type_km')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_km">
              <FiledIsRequired :msg="validations['name_km'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.name_en }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="name_en"
          >{{ $t("field.label.project_type_en") }}</label>
          <div class="col-sm-9">
            <input
              id="name_en"
              v-model="projectType.name_en"
              :placeholder="$t('field.pla.project_type_en')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_en">
              <FiledIsRequired :msg="validations['name_en'][0]" />
            </template>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <template v-if="$route.params.uuid">
              <button
                class="btn btn-info btn-sm margin-r-5"
                @click="update"
              >
                <i class="fa fa-check-circle" /> {{ $t("button.update") }}
              </button>
            </template>
            <template v-else>
              <button
                class="btn btn-primary btn-sm margin-r-5"
                @click="store"
              >
                <i class="fa fa-check-circle" /> {{ $t("button.save") }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FiledIsRequired from '@/components/FiledIsRequired'

export default {
  name: 'Form',
  components: { FiledIsRequired },
  data () {
    return {
      projectType: {
        name_en: null,
        name_km: null
      },
      validations: {}
    }
  },
  mounted () {
    this.getProjectType()
  },
  methods: {
    store () {
      this.validations = {}
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/backend/project-types', this.projectType)
        .then(() => {
          this.showToastr()
          this.$router.push({
            name: 'list-project-type'
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    update () {
      this.validations = {}
      this.$isLoading(true)
      this.projectType.project_type_uuid = this.$route.params.uuid
      this.$axios.put(process.env.VUE_APP_API + '/api/backend/project-types', this.projectType)
        .then(() => {
          this.showToastr()
          this.$router.push({
            name: 'list-project-type'
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    getProjectType () {
      if (!this.$route.params.uuid) {
        return 0
      }
      this.$isLoading(true)
      this.$axios.get(process.env.VUE_APP_API + '/api/backend/project-types/' + this.$route.params.uuid)
        .then(({ data }) => {
          if (data.data) {
            this.projectType = data.data
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped></style>
